import type { NotesTableColumnKeys } from "../types";

export const NOTES_TABLE_COLUMNS_KEYS: Record<NotesTableColumnKeys, NotesTableColumnKeys> = {
  direction: "direction",
  dueDate: "dueDate",
  important: "important",
  noteDate: "noteDate",
  noteTitle: "noteTitle",
  person: "person",
  status: "status",
  title: "title",
  type: "type",
};
